// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import StoneTypesForm from './StoneTypesForm';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(StoneTypesForm);
